
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import { IOrgForm } from '@/types/org.d';
import tableMixin from './tableMixin';

@Component({
  components: {
    Pagination,
  },
})
export default class ManageView extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/helpQues:add',
    icon: 'plus',
    callback: this.handleAddForm,
    log: {
      name: '机构管理 - 新增',
      component: 'org/mange/components/bModal',
    },
  }];

  /**
   * @author liangyongmou
   * @desc 添加机构
   */
  handleAddForm() {
    this.$router.push({ name: 'helpQues/operate' });
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
